

















import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
})
export default class EcoPost extends Vue {
    private eCoTableHeader = ['พิกัดน้ำหนัก', 'อัตราค่าบริการ (บาทต่อชิ้น)'];
    private eCoTableDetail = [
        {weight: 'ไม่เกิน 20 กรัม', price: '20'},
        {weight: 'เกิน 20 กรัมแต่ไม่เกิน 100 กรัม', price: '22'},
        {weight: 'เกิน 100 กรัมแต่ไม่เกิน 250 กรัม', price: '26'},
        {weight: 'เกิน 250 กรัมแต่ไม่เกิน 500 กรัม', price: '30'},
        {weight: 'เกิน 500 กรัมแต่ไม่เกิน 1,000 กรัม', price: '40'},
        {weight: 'เกิน 1,000 กรัมแต่ไม่เกิน 2,000 กรัม', price: '60'},
        {weight: 'เกิน 2,000 กรัมแต่ไม่เกิน 4,000 กรัม', price: '80'},
        {weight: 'เกิน 4,000 กรัมแต่ไม่เกิน 6,000 กรัม', price: '120'},
        {weight: 'เกิน 6,000 กรัมแต่ไม่เกิน 10,000 กรัม', price: '160'},
    ];
}
